import React, { useState } from "react";
// import { Link } from "react-router-dom";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import steps1 from "../../../images/categories/steps/PPI-steps-001.jpg";
import steps2 from "../../../images/categories/steps/PPI-steps-002.jpg";
import steps3 from "../../../images/categories/steps/PPI-steps-003.jpg";
import steps4 from "../../../images/categories/steps/PPI-steps-004.jpg";
import steps5 from "../../../images/categories/steps/PPI-steps-005.jpg";
import steps6 from "../../../images/categories/steps/PPI-steps-006.jpg";
import steps7 from "../../../images/categories/steps/PPI-steps-007.jpg";
import steps8 from "../../../images/categories/steps/PPI-steps-008.jpg";
import steps9 from "../../../images/categories/steps/PPI-steps-009.jpg";
import steps10 from "../../../images/categories/steps/PPI-steps-010.jpg";
import steps11 from "../../../images/categories/steps/PPI-steps-011.jpg";
import steps12 from "../../../images/categories/steps/PPI-steps-012.jpg";
import steps13 from "../../../images/categories/steps/PPI-steps-013.jpg";
import steps14 from "../../../images/categories/steps/PPI-steps-014.jpg";
import steps15 from "../../../images/categories/steps/PPI-steps-015.jpg";
//Utils
import { mapGallery } from "../../../../../Utils/Utils";

//SEO
import SEO from "../../../../../SEO/index";
import StructuredData from "../../../../../SEO/structuredData";

const Steps = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: steps1,
      description:
        "Hardscaped backyard with custom concrete steps with rustic step lights built in. This design features multiple hardscape materials including concrete, paving stone, natural stones and stucco.",
      aria: "Hardscaped backyard with custom concrete steps with lights built in",
    },
    {
      image: steps2,
      description:
        "Tumbled paver steps with landscape lighting and step lighting.",
      aria: "Tumbled paver steps with landscape lighting and step lighting",
    },
    {
      image: steps3,
      description:
        "Understated single step ellevation rise in a paving stone walkway with a water feature on the left side.",
      aria: "Single step ellevation rise in a paving stone walkway with a water feature on the left side",
    },
    {
      image: steps4,
      description:
        "Tumbled paving stone steps flanked by a multi dimensional water feature. The combination of the rustic stones and drought tolerant plants gives off a natural feeling and makes a statement piece out of a simple walkway.",
      aria: "Tumbled paving stone steps flanked by a multi dimensional water feature and drought tolerant plants",
    },
    {
      image: steps5,
      description:
        "Large hardscape staircase with double lighting on each step leading up to a raised patio and gazebo with.",
      aria: "Hardscape staircase with double lighting on each step leading up to a raised patio and gazebo",
    },
    {
      image: steps6,
      description:
        "Retaining wall, walkway and fire pit leading up to a dining and lounge area covered by a custom gazebo. Paving stone steps were used to traverse this backyard’s massive elevation change and tie each space together cohesively.",
      aria: "Retaining wall, walkway and fire pit leading up to a dining and lounge area covered by a gazebo",
    },
    {
      image: steps7,
      description:
        "Brick colored paving stone staircase leading up to additional patio space. This walkway is constructed with stucco, pavers, brick accents and includes a pathway light built into each step.",
      aria: "Brick colored paving stone staircase leading up to additional patio space",
    },
    {
      image: steps8,
      description:
        "Daytime shot of a modern walkway constructed from large tumbled paving stones. Lighting options for this space include landscape lights as well as automatic outdoor lights built into the step.",
      aria: "Daytime shot of a modern walkway constructed from large tumbled paving stones",
    },
    {
      image: steps9,
      description:
        "Sand colored tile steps leading to an overlooking garden area with a built in safety rail in Encino, CA.",
      aria: "Sand colored tile steps leading to an overlooking garden area with a safety rail in Encino, CA",
    },
    {
      image: steps10,
      description:
        "Shallow concrete slab steps with lighting leading to a backyard setting area adjacent to the pool. This hardscaping project in Santa Clarita, CA features a new pool and spa, a retaining wall and large patio deck.",
      aria: "Shallow concrete slab steps with lighting leading to a backyard setting area adjacent to the pool",
    },
    {
      image: steps11,
      description:
        "Modern tile steps leading to this Los Angeles home’s entryway.",
      aria: "Modern tile steps leading to a Los Angeles home’s entryway",
    },
    {
      image: steps12,
      description:
        "Sand colored paving stone patio with tumbled paver steps in Glendale, CA.",
      aria: "Sand colored paving stone patio with tumbled paver steps in Glendale, CA",
    },
    {
      image: steps13,
      description:
        "Modern tile stairway with industrial looking railing in a backyard of Eagle Rock, CA.",
      aria: "Modern tile stairway with industrial looking railing in a backyard of Eagle Rock, CA",
    },
    {
      image: steps14,
      description:
        "Poured concrete stairway with step lighting as well as landscape lighting. This massive hardscape project in Bellair, CA included fake rocks, retaining wall planter beds, fire pits, paving stone patios and more.",
      aria: "Concrete stairway with lighting in Bellair, CA with rocks, retaining walls, & fire pits",
    },
    {
      image: steps15,
      description:
        "Brick steps leading to a covered patio and outdoor kitchen in Los Angeles, CA. These brick steps are a perfect way to transition  from a paving stone walkway into a brick patio.",
      aria: "Brick steps leading to a covered patio and outdoor kitchen in Los Angeles, CA",
    },
  ];

  return (
    <>
      <SEO
        title="Paver Steps & Coping Ideas | Los Angeles | Pacific Pavingstone"
        description="View the beautiful outdoor paver steps projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={
          "https://www.pacificpavingstone.com/gallery/steps-and-coping"
        }
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Paver Steps and Coping Gallery",
          description:
            "View the beautiful outdoor paver steps projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/PPI-steps-005.76adc11e.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "steps", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default Steps;
